import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { ReactComponent as Briefcase } from "../../_asset/img/briefcase.svg";
import { ReactComponent as Chart } from "../../_asset/img/chart.svg";
import { ReactComponent as Key } from "../../_asset/img/key.svg";
import { ReactComponent as Logout } from "../../_asset/img/logout.svg";
import { useUser } from "../../../context/UserContext";
import { logout } from "../../../services/userService";
import { getUserProviderManagers } from "../../../services/staffingService";

const OfficerDashboardSidebar = ({ isOpen }) => {
  const location = useLocation();
  const { userInfo } = useUser();
  const [providerCompanies, setProviderCompanies] = useState([]);
  const providerCompanyId = useParams().providerCompanyId;

  useEffect(() => {
    fetchProviderCompanies();
  }, []);

  const fetchProviderCompanies = async () => {
    const resp = await getUserProviderManagers();
    setProviderCompanies([...resp.data]);
  };

  const isActive = (path) => {
    return location.pathname.includes(path);
  };

  const initiateLogout = async () => {
    const resp = await logout();
    window.location.href = resp.data.logoutUrl;
  };

  const getCurrentCompanyDetails = (providerCompanies, providerCompanyId) => {
    const currentCompany = providerCompanies.find(
      (providerCompany) =>
        providerCompany.provider_company_id._id === providerCompanyId
    );
    if (!currentCompany) return { name: "Select a Company", avatarInitial: "S" };

    const companyName =
      currentCompany.provider_company_id?.agency_name || "N/A";
    const avatarInitial = companyName.split(" ")[0]?.charAt(0).toUpperCase() || "U";

    return { name: companyName, avatarInitial };
  };

  const { name, avatarInitial } = getCurrentCompanyDetails(
    providerCompanies,
    providerCompanyId
  );

  return (
    <div className={`sidebar ${isOpen ? "active" : ""}`}>
      <div className="sidebar-header" style={{ textAlign: "center", padding: "24px", borderBottom: "1px solid #E4E4E4" }}>
        <Link to="/home" className="profile" style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%", textDecoration: "none" }}>
          <div 
            className="w-10 h-10 rounded-full border border-gray-300 flex items-center justify-center text-white font-medium"
            style={{ backgroundColor: "#CC457D" }}
          >
            {avatarInitial}
          </div>
          <div className="user_details" style={{ transition: "all 0.3s" }}>
            <p className="name" style={{ fontWeight: 600, margin: 0, color: "#000000" }}>{name}</p>
            <span className="roll" style={{ fontSize: "12px", fontWeight: 400, color: "#878787", textAlign: "left" }}>Click to switch organization</span>
          </div>
        </Link>
      </div>

      <div className="navbar_wrapper" id="scrollBar" style={{ padding: "24px", height: "calc(100vh - 94px)", display: "flex", flexDirection: "column", justifyContent: "space-between", overflowY: "auto" }}>
        <div className="navbar_inner" style={{ marginBottom: "24px" }}>
          <h4 className="title" style={{ fontSize: "12px", fontWeight: 500, marginBottom: "8px", color: "#878787", transition: "all 0.3s" }}>MAIN MENU</h4>
          <nav className="sidebar-nav" style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <Link
              to={`/provider-resource/${providerCompanyId}/dashboard/work-order/open`}
              className={`${isActive("work-order") ? "active" : ""}`}
              style={{ color: "#68686A", padding: "12px", borderRadius: "8px", display: "flex", alignItems: "center", fontSize: "14px", gap: "8px", fontWeight: 500, textDecoration: "none" }}
            >
              <Briefcase />
              <span>Work Orders</span>
            </Link>
            <Link
              to={`/provider-resource/${providerCompanyId}/dashboard/performance`}
              className={`${isActive("performance") ? "active" : ""}`}
              style={{ color: "#68686A", padding: "12px", borderRadius: "8px", display: "flex", alignItems: "center", fontSize: "14px", gap: "8px", fontWeight: 500, textDecoration: "none" }}
            >
              <Chart />
              <span>Performance</span>
            </Link>
            <Link
              to={`/provider-resource/${providerCompanyId}/dashboard/account`}
              className={`${isActive("account") ? "active" : ""}`}
              style={{ color: "#68686A", padding: "12px", borderRadius: "8px", display: "flex", alignItems: "center", fontSize: "14px", gap: "8px", fontWeight: 500, textDecoration: "none" }}
            >
              <Key />
              <span>Account</span>
            </Link>
          </nav>
        </div>

        <div className="navbar_inner">
          <h4 className="title" style={{ fontSize: "12px", fontWeight: 500, marginBottom: "8px", color: "#878787", transition: "all 0.3s" }}>OTHERS</h4>
          <nav className="sidebar-nav" style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <Link
              to={`/`}
              onClick={initiateLogout}
              className={`logout ${isActive("logout") ? "active" : ""}`}
              style={{ color: "#FF5C57", padding: "12px", borderRadius: "8px", display: "flex", alignItems: "center", fontSize: "14px", gap: "8px", fontWeight: 500, textDecoration: "none" }}
            >
              <Logout />
              <span>Logout</span>
            </Link>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default OfficerDashboardSidebar;
